import { createStore } from 'vuex'
import { TUser } from './modules/types'

export default createStore({
  state: {
    showSidebar : true,
    apiUrl: process.env.VUE_APP_API_URL,
    websiteUrl: process.env.VUE_APP_WEBSITE_URL,
    currentUser: <TUser> {}
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
